import { Component, Input, OnDestroy } from '@angular/core';

import { OnInit } from '@angular/core';
import { PrintService } from 'src/services/print.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { AlertComponent } from '../alert/alert.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'rm-print-label',
  templateUrl: './print-label.component.html',
  styleUrls: ['./print-label.component.css']
})
export class PrintLabelComponent implements OnInit {

  arrayBuffer: any;
  file: File;
  labels: any[];
  formats: any[];

  selectedFormat: string;
  labelImg: any = '';
  base64Img: string;
  base64Arr: any[] = [];
  printImg: boolean;

  constructor(
    private printService: PrintService,
    private domSanitizer: DomSanitizer,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.printService.getPrintFormats().subscribe(
      (result: any) => {
        this.formats = result['data'];
      });
  }

  /*
  * This method is only for testing. It is used in print format.
  */
  getHRI = function (txt) {
    var txtArr = txt.split(' ');
    var ln = txtArr.length;
    var res = [];	//as per DGFT
    for (var i = 0; i < ln; i++) {
      var t = txtArr[i];
      if (t.indexOf('(01)') > -1) {
        t= t.replace('(01)', 'GTIN (01): ');
        res.splice(0, 0, t);
      }
      if (t.indexOf('(17)') > -1) {
        t = t.replace('(17)', 'Exp (17): ');
        res.splice(1, 0, t);
      }
      if (t.indexOf('(10)') > -1) {
        t = t.replace('(10)', 'Batch No (17): ');
        res.splice(2, 0, t);
      }
      if (t.indexOf('(21)') > -1) {
        t = t.replace('(21)', 'S. No (21): ');
        res.splice(3, 0, t);
      }
    }

    return unescape(res.join('<br/>'));
  }

  print(format, labels) {
    if (!format) {
      const dialogRef = this.dialog.open(AlertComponent, {
        width: "450px",
        data: {
          note: "Please select a print format before printing",
        },
      });

      return;
    }

    var printWin = window.open('', 'new div', 'height=400,width=600');
    var htmlStr = this.printService.getHtmlStr(format, labels);

    // console.log('HRI: ', this.getHRI(labels[0].hri));

    // console.log(htmlStr);

    printWin.document.write(htmlStr);
    printWin.print();
    // printWin.close();
  }

  generateImg() {
    if (this.base64Arr.length > 0) {
      this.base64Arr = [];
    }
    var img = 'data:image/png;base64,' + this.base64Img;
    this.labelImg = this.domSanitizer.bypassSecurityTrustUrl(img);
    this.printImg = true;

    var obj = {
      img: img
    };
    this.base64Arr.push(obj);
  }

  incomingfile(event) {
    this.file = event.target.files[0];
  }

  uploadFile() {
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.file);
    fileReader.onload = (e) => {
      this.labels = [];
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      // console.log(XLSX.utils.sheet_to_json(worksheet,{raw:true}));
      var arrayList = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      arrayList.forEach(element => {
        var img = 'data:image/png;base64,' + element["Label"];
        element["img"] = img;
        element["hri"] = element["HRI"];
        delete element['HRI'];
      });
      this.labels = arrayList;
      // console.log("label files: ", this.labels);
    }
  }
}